import { IApplicationState } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkArchivedCards = (
    state: IApplicationState
): boolean => {
    return getAuthUserMetaMyWork(state).isShowArchivedCards;
};
